import React from "react";
import { Field, useFormState } from "react-final-form";

import { NavigationButton } from "../components/NavigationButton";
import { FormData, FormResources } from "../types/formData";
import { Navigation } from "../types/navigation";
import { checkForOption } from "../utils/checkForOption";
import { RadioButtonsContainer } from "../valuation-manager.styles";

interface MechanicalAndElectricalPageProps {
  setPageName: (pageName: Navigation) => void;
  formResources: FormResources;
}

export const MechanicalAndElectricalPage: React.FC<
  MechanicalAndElectricalPageProps
> = ({ setPageName, formResources }) => {
  const { values }: { values: FormData } = useFormState();

  const isAnyOptionSelected = !!values.faults && values.faults.length > 0;
  const isNoSelected = checkForOption(values.faults, "no");
  const isOtherSelected = checkForOption(values.faults, "other");

  return (
    <div>
      <div className="row">
        <RadioButtonsContainer className="col-sm-12 col-md-12 col-lg-12">
          <legend>{formResources.mechanics.title}</legend>
          {formResources.mechanics.options.map((option) => (
            <div className="checkbox" key={option.value}>
              <label>
                <Field
                  name="faults"
                  component="input"
                  type="checkbox"
                  value={option.value}
                  disabled={isNoSelected}
                  aria-label={option.value}
                />
                {option.label}
              </label>
            </div>
          ))}
          <Field name="faults" subscription={{ value: true }}>
            {({ input: { value } }) => {
              return value.includes("other") ? (
                <div className="form-group">
                  <label>
                    Fault details:&nbsp;
                    <Field
                      component="textarea"
                      name="known_faults"
                      rows={7}
                      cols={100}
                      minLength={10}
                      required={isOtherSelected}
                      className="form-control"
                      disabled={isNoSelected}
                      data-testid="mechanical-textarea"
                    />
                  </label>
                </div>
              ) : null;
            }}
          </Field>
          <div className="checkbox">
            <label>
              <Field
                name="faults"
                component="input"
                type="checkbox"
                value="no"
                aria-label="no"
              />
              No
            </label>
          </div>
        </RadioButtonsContainer>
      </div>
      <NavigationButton setPageName={setPageName} disabled={!isAnyOptionSelected} />
    </div>
  );
};
